import React from "react";
import PayloftLogo from "../assets/images/payloft-logo.png";

const SignUpOtp = () => {
  return (
    <div className="flex justify-center">
      <div className="w-[448px] p-4">
        <div className="flex items-center justify-center">
          <img src={PayloftLogo} alt="logo" className="w-full h-auto" />
        </div>
        <h1 className="text-[25px] font-semibold  text-center mt-20">
          Sign up
        </h1>
        <h1 className="text-[25px] font-semibold border-b pb-16 text-center">
          Verify Account
        </h1>
        <div className="mt-6">
          <div className="w-[294px] mx-auto">
            <p className="text-[15px] text-center font-normal">
              Enter 4-digit Code code we have sent to at{" "}
              <span className="text-text-orange font-bold">
                +0 000 000 0000
              </span>
              <span className="text-text-orange font-normal"> and</span>
              <span className="text-text-orange font-bold">
                {" "}
                d******@*******.com
              </span>
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 mt-8">
          <input className="bg-text-orange text-white text-[35px] text-center w-[70px] h-[70px] rounded-xl focus:outline-none" />
          <input className="bg-text-orange/20 text-text-orange text-[35px] text-center w-[70px] h-[70px] rounded-xl focus:outline-none" />
          <input className="bg-light-grey text-white text-[35px] text-center w-[70px] h-[70px] rounded-xl focus:outline-none" />
          <input className="bg-light-grey text-white text-[35px] text-center w-[70px] h-[70px] rounded-xl focus:outline-none" />
        </div>
        <p className="font-normal text-[15px] text-center text-dark-grey mt-6">
          This session will end in 60 seconds.
        </p>
        <p className="font-normal text-[15px] text-center text-dark-grey mt-2">
          Didn&#39;t get code?{" "}
          <span className="underline text-text-orange">Resend Code</span>
        </p>
        <div className="mt-10">
          <button className="bg-text-orange w-[410px] h-[50px] text-white rounded-md">
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpOtp;
